import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-icons",
    styleUrls: ["./icons.component.scss"],
    templateUrl: "./icons.component.html",
    standalone: false
})
export class FUIIconsComponent {

}
